import { Component } from '@angular/core';
import { ForumService } from 'app/products/bi/services/forum.service';

@Component({
    standalone: true,
    selector: 'badge-rating',
    template: `
        <div
            class="badge-container"
            [attr.aria-label]="'User level: ' + (forumService.levelName || '')"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                [attr.fill]="forumService.levelColor"
                width="24"
                height="24"
                viewBox="-4.5 0 32 32"
            >
                <path
                    d="M5.52 26.96c-0.4 0 -0.8-0.12 -1.08-0.32c-1.68-1.2 -0.28-5.32 0.68-7.6
                 c-2.12-1.32 -5.68-3.84 -5.04-5.76c0.4-1.2 2.08-1.76 5.28-1.76c0.84 0 1.64 0.04 2.16 0.08
                 c0.56-2.44 1.88-6.56 3.92-6.56s3.36 4.16 3.92 6.56c0.56-0.04 1.32-0.08 2.16-0.08
                 c3.2 0 4.88 0.56 5.28 1.76c0.64 1.96 -2.92 4.48 -5.04 5.76c0.96 2.28 2.36 6.4 0.68 7.6
                 c-0.28 0.2 -0.68 0.32 -1.08 0.32c-1.8 0 -4.64-2.24 -5.96-3.32c-1.24 1.08 -4.08 3.32 -5.88 3.32"
                />
            </svg>
        </div>
    `,
    styles: [
        `
            .badge-container {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 25px;
                width: 30px;
                border-radius: 9999px;
                background-color: rgba(209, 210, 213, 0.72);
                padding: 2px;
            }

            svg {
                width: 20px;
                display: block;
            }
        `,
    ],
})
export class PioneerBadgeComponent {
    constructor(public forumService: ForumService) {}
}
